// hooks/useUsers.ts

import { useQueryClient } from "@tanstack/react-query";
import { User } from "../interfaces/DTO/user";
import { queryKeys } from "../queries/queryKeys";
import { userService } from "../services/userService";
import { createCachedEntityHooks } from "./createEntityHooks";
import { CacheManager } from "./cacheManager";
import { useMutation } from "@tanstack/react-query";

// ✅ hook-ים גנריים
export const {
  useAll: useUsers,
  useEntityById: useUserById,
  useCreateEntity: useCreateUser,
  useUpdateEntity: useUpdateUser,
  usePartialUpdateEntity: usePartialUpdateUser,
  useDeleteEntity: useDeleteUser,
} = createCachedEntityHooks<User>({
  entityName: "users",
  service: userService,
  enableCacheById: true,
  staleTimeMs: 5000,
});

// ✅ פעולה מיוחדת: יצירת משתמש עם פרטיות


// ✅ הוספה ידנית ל־cache
export const useAddUsersToCache = () => {
  const queryClient = useQueryClient();

  return (users: User[]) => {
    users.forEach((user) => {
      queryClient.setQueryData<User>(queryKeys.userById(user.id), user);
    });

    queryClient.setQueryData<User[]>(queryKeys.users, (oldUsers) => {
      if (!oldUsers) return users;

      const updated = [...oldUsers];
      users.forEach((newUser) => {
        const index = updated.findIndex((u) => u.id === newUser.id);
        if (index === -1) {
          updated.push(newUser);
        } else {
          updated[index] = newUser;
        }
      });

      return updated;
    });
  };
};
